import { lazy } from 'react';
import { Navigate, createBrowserRouter } from 'react-router';
import Loadable from '../layouts/full/shared/loadable/Loadable';
import RequireInternal from './RequireInternal';

const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

const BoardView = Loadable(lazy(() => import('../views/board')));
const WorkItems = Loadable(lazy(() => import('../views/work-items')));
const Tickets = Loadable(lazy(() => import('../views/tickets')));
const TicketDetail = Loadable(lazy(() => import('../views/tickets/detail')));
const Changelog = Loadable(lazy(() => import('../views/changelog')));
const Errors = Loadable(lazy(() => import('../views/errors')));
const Logs = Loadable(lazy(() => import('../views/logs')));
const KnowledgeBase = Loadable(lazy(() => import('../views/kb')));
const Tests = Loadable(lazy(() => import('../views/tests')));
// Lazy like every page, and more so than most: it carries the Perspective pivot
// engine, whose WebAssembly should download on this page and nowhere else.
const AiPerformance = Loadable(lazy(() => import('../views/ai-performance')));
// AI performance → Evaluation (HQ #121). Each page is its own chunk, like every page.
const EvaluationLayout = Loadable(lazy(() => import('../views/ai-performance/evaluation/layout')));
const EvaluationRuns = Loadable(lazy(() => import('../views/ai-performance/evaluation/runs')));
const EvaluationRunReport = Loadable(lazy(() => import('../views/ai-performance/evaluation/run-report')));
const EvaluationDataset = Loadable(lazy(() => import('../views/ai-performance/evaluation/dataset')));
const EvaluationCase = Loadable(lazy(() => import('../views/ai-performance/evaluation/case-editor')));
const EvaluationLabels = Loadable(lazy(() => import('../views/ai-performance/evaluation/labeller')));
const Login = Loadable(lazy(() => import('../views/auth/login')));
const ErrorPage = Loadable(lazy(() => import('../views/auth/error')));

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <RequireInternal>
        <FullLayout />
      </RequireInternal>
    ),
    children: [
      { path: '/', element: <BoardView /> },
      { path: '/work-items', element: <WorkItems /> },
      { path: '/tickets', element: <Tickets /> },
      { path: '/tickets/:ticketId', element: <TicketDetail /> },
      { path: '/changelog', element: <Changelog /> },
      { path: '/errors', element: <Errors /> },
      { path: '/logs', element: <Logs /> },
      { path: '/knowledge-base', element: <KnowledgeBase /> },
      { path: '/tests', element: <Tests /> },
      { path: '/ai-performance', element: <AiPerformance /> },
      {
        path: '/ai-performance/evaluation',
        element: <EvaluationLayout />,
        children: [
          { index: true, element: <Navigate to="runs" replace /> },
          { path: 'runs', element: <EvaluationRuns /> },
          { path: 'runs/:runId', element: <EvaluationRunReport /> },
          { path: 'dataset', element: <EvaluationDataset /> },
          { path: 'dataset/:caseKey', element: <EvaluationCase /> },
          { path: 'dataset/:caseKey/labels', element: <EvaluationLabels /> },
        ],
      },
      { path: '*', element: <Navigate to="/404" /> },
    ],
  },
  {
    path: '/',
    element: <BlankLayout />,
    children: [
      { path: '/login', element: <Login /> },
      { path: '/404', element: <ErrorPage /> },
    ],
  },
]);

export default router;
